import { compose, length, map, times } from 'ramda';

import { unprefix } from '../../../../helpers/compact';
import { CommonSliceType } from '../../../../types/slice';
import { toTextFromProp } from '../../fields/text';
import { toBooleanFromProp } from '../../fields/boolean';

export const quiz = ({ primary, items = [] }) => {
  const questions = map(
    ({ question, illustration, ...rest }) => ({
      question,
      illustration,
      answers: times(
        compose(
          (answer) => ({
            text: toTextFromProp('text', answer),
            isGood: toBooleanFromProp('is_good', answer),
          }),
          (idx) => unprefix(`answer_${idx + 1}`, rest)
        ),
        3
      ),
    }),
    items
  );

  if (length(questions)) {
    return {
      type: CommonSliceType.QUIZ,
      title: toTextFromProp('title', primary),
      questions: questions,
    };
  }
};
